import React from "react";
import { useContext, useState  } from "react";
import { Plus, Minus  } from 'lucide-react';

function ChevronDownIcon({ className }) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </svg>
  );
}



const Faqsection = () => { 

    const faqs = [
        {
            question: "What is Industry & People?",
            answer:"Industry & People is a professional survey platform where industry experts, professionals, and organizations can join, create, and participate in surveys to share insights, support research, and earn honorariums for their time.",
        },
        {
            question: "Who can join Industry & People?",
            answer:"Professionals from all industries—including business leaders, consultants, subject-matter experts, startups, enterprises, and research organizations—can join the platform to create surveys or participate in them.",
        },
        {
            question: "What types of surveys are supported?",
            answer:"The platform supports market research surveys, industry trend studies, product and service feedback surveys, employee or organizational assessments, and decision-making research studies.",
        },
        {
            question: "Is Industry & People free to use?",
            answer: "Yes. Joining Industry & People is completely free. Users can register, explore surveys, and participate without any upfront cost.",
        },
        {
            question: "How does Industry & People ensure survey relevance?",
            answer: "Surveys are matched based on industry, role, expertise, and professional background, ensuring participants receive relevant and meaningful survey opportunities",
        },
        {
            question: "Why should professionals and organizations use Industry & People?",
            answer: "Professionals gain a chance to share expertise and earn honorariums, while organizations benefit from high-quality insights directly from industry-relevant audiences, helping them make better data-driven decisions.",
        },
    ];

    const [openIndex, setOpenIndex] = useState(0); // first one open by default
    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };





  return (

        <section className="ptb60px px-3 faqpage">
            <div className="container w-75">
        
                {/* Heading */}
                <div className="headingbox text-center mb-5" data-aos="fade-up">
                <h2 className="headinglg px-6 text-left" style={{ color: "#323539" }}>
                    <span className="uline">Have Questions? We've got answers!</span>
                </h2> 
        
                <p className="ft-18" style={{ color: "#746E6E" }}>
                    Find answers to the most commonly asked questions about inp.com
                </p>
                </div>
        
                {/* FAQ Grid */}
                <div className="row g-3" data-aos="fade-up">
                    {faqs.map((faq, index) => (
                    <div key={index} className="col-12" data-aos="fade-up">

                        <div className="border rounded overflow-hidden">

                        {/* Question */}
                        <button
                            className="w-100 d-flex justify-content-between align-items-center p-3 text-start fw-semibold"
                            style={{ fontSize: "16px", fontWeight: 700, color: "#252525" }}
                            onClick={() => toggleFAQ(index)}
                        >
                            {faq.question}

                            {openIndex === index ? (
                            <Minus size={22} className="text-secondary transition-icon" />
                            ) : (
                            <Plus size={22} className="text-secondary transition-icon" />
                            )}
                        </button>

                        {/* Answer */}
                        <div
                            className={`faq-answer ${
                            openIndex === index ? "open" : ""
                            }`}
                        >
                            <p className="mb-0" style={{ fontSize: "16px", fontWeight: 400, lineHeight: "24px", color: "#2B2D2F" }}>
                            {faq.answer}
                            </p>
                        </div>

                        </div>

                    </div>
                    ))}
                </div>
        
            </div>
        </section>

      );
};

export default Faqsection;